export const SERIES_BREAK = 'seriesBreak';
